<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Offices">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Keys</b-breadcrumb-item>
            <b-breadcrumb-item active>{{keyNumber}}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Key Number {{keyNumber}}</div>
            <div class="card-body">
                <div class="pb-3">
                  <b>Key Type:</b> {{ facilitiesKeyTypeName }}
                </div>
                <div class="card">
                    <div class="card-header">
                        <ul class="card-header-tabs nav nav-tabs">
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheFacilitiesKeyLockList'" class="active nav-link"
                                   data-toggle="tab"
                                   href="#">Locks</a>
                            </li>
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheFacilitiesKeyCopyList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Copies</a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-container">
                        <keep-alive>
                            <component :facilities-key-id="id"
                                       :facilities-key-type-name="facilitiesKeyTypeName"
                                       :facilities-key-number="keyNumber"
                                       :facilities-key-type-id="facilitiesKeyTypeId" v-bind:is="currentTabComponent"/>
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import TheFacilitiesKeyLockList from "@/components/facilitiesKeys/TheFacilitiesKeyLockList.vue";
    import TheFacilitiesKeyCopyList from "@/components/facilitiesKeys/TheFacilitiesKeyCopyList.vue";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";

    export default {
        components: {
            TheFacilitiesKeyLockList,
            TheFacilitiesKeyCopyList
        },
        data() {
            return {
                keyNumber: null,
                facilitiesKeyTypeId: null,
                facilitiesKeyTypeName: null,
                currentTabComponent: 'TheFacilitiesKeyLockList',
            }
        },
        props: {
            id: {
              type: String,
              required: true
            }
        },
        methods: {
          loadData () {
            const vm = this;

            FacilitiesKeysService.getFacilitiesKey(this.id)
              .then(response => {
                this.keyNumber = response.keyNumber;
                this.facilitiesKeyTypeName = response.facilitiesKeyTypeName;
                this.facilitiesKeyTypeId = response.facilitiesKeyTypeId;
              })
              .catch(() => {
                vm.redirectToError()
              })
          }
        },
        created () {
          this.loadData();
        }
    }
</script>
